<h1 mat-dialog-title>{{ data.dialog_title }}</h1>

<mat-dialog-content>
  <mat-form-field appearance="fill">
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      [matDatepicker]="picker"
      [matDatepickerFilter]="filter"
      [ngModel]="selected_date"
      (ngModelChange)="selected_date = $event"
      [min]="min_date"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="accent" (click)="submit()">{{ data.dialog_ok_button }}</button>
</mat-dialog-actions>
